import { apiCall } from "./api";

export const getWorkspaces = (offset, searchStr, userId = "") => {
  const userData = JSON.parse(localStorage.getItem("userData"));
  const url =
    "/api/v1/workspace-a" +
    `?offset=${offset}&limit=24` +
    (searchStr ? `&text=${searchStr}` : "") +
    (userId ? `&userId=${userId}` : "");

  return apiCall(
    url,
    {
      method: "GET",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      credentials: "include",
    },

    "WORKSPACES",
  );
};

export const getWorkspaceForUser = (userId, offset = 0) => {
  const userData = JSON.parse(localStorage.getItem("userData"));
  const url =
    "/api/v1/workspace-a" + "?userId=" + userId + `&offset=${offset}&limit=24`;
  return apiCall(
    url,
    {
      method: "GET",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      credentials: "include",
    },

    "WORKSPACES",
  );
};

export const getAllWorkspaceNames = () => {
  return apiCall("/api/v1/get-all-workspaces", {
    method: "GET",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
    credentials: "include",
  });
};

export const getWorkspaceDetails = (workspaceId) => {
  console.log("@getWorkspaceDetails");
  const url = `/api/v1/workspace/${workspaceId}/manage`;
  return apiCall(url, {
    method: "GET",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
    credentials: "include",
  });
};

export const createWorkspace = (data) => {
  return apiCall("/api/v1/workspace", {
    method: "POST",
    headers: {
      Accept: "application/json",
      // "Content-Type": "application/json",
    },
    credentials: "include",
    body: data,
  });
};

export const updateWorkspace = (workspaceId, data) => {
  return apiCall("/api/v1/workspace/" + workspaceId, {
    method: "PUT",
    body: data,
    credentials: "include",
  });
};

export const leaveWorkspace = (workspaceId) => {
  const url = "/api/v1/workspace/" + workspaceId + "/leave";
  return apiCall(url, {
    method: "DELETE",
    credentials: "include",
  });
};

export const deleteWorkspace = (workspaceId) => {
  return apiCall(`/api/v1/workspace/${workspaceId}`, {
    method: "DELETE",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
    credentials: "include",
    body: JSON.stringify({ workspaceId }),
  });
};

export const getHighestRoleInWorkspace = (workspaceId) => {
  return apiCall(
    `/api/v1/workspace/get-highest-role/${workspaceId}`,
    {
      method: "GET",
      credentials: "include",
    },
    "USER_ROLE",
  );
};

export const getWorkspaceServices = (workspaceId) => {
  return apiCall(
    `/api/v1/workspace/${workspaceId}/service`,
    {
      method: "GET",
      credentials: "include",
    },
    "ACTIVE_SERVICES",
  );
};
